import React from "react";
import {
  ClinithinkUserIconSVG,
  PartnerAdminIconSVG,
} from "../../Assets/SVGs/ResourceSVGs";
import "./DatagridCells.scss";

export const resourceGridStatus = (cellData) =>
  cellData?.data?.active === false ||
  cellData?.data?.resourceVersion?.active === false ? (
    <div className="deprecatedClass" title="Deprecated">
      Deprecate
    </div>
  ) : (
    <div className="activeClass" title="Active">
      Active
    </div>
  );

export const resourceGridIcon = (cellData) => (
  <div className="org-div">
    {cellData.data.isClinithinkResource ? (
      <span>{ClinithinkUserIconSVG}</span>
    ) : (
      <span>{PartnerAdminIconSVG}</span>
    )}
    <span className="tool-tip-for-author">{cellData.data.authorOrganization}</span>
  </div>
);
